module.exports = __webpack_public_path__ + "img/gridBg.2548704a.png";